import {whenReady} from "../general/Util";
import MiniBasket from "../libs/MiniBasket";

class BasketItemActions {

	constructor( basketItemEl ) {
		this.basketItemEl = basketItemEl;

		this.selectEls = this.basketItemEl.querySelectorAll( '.amount_selector' );
		this.selectEls.forEach( selectEl => {
			selectEl.addEventListener( 'change', ( ev ) => this.onChange( ev.target ) )
		} );

		this.buttonEls = this.basketItemEl.querySelectorAll( '.mdl_article_item__addtocart' );
		this.buttonEls.forEach( buttonEl => {
			buttonEl.addEventListener( 'click', ( ev ) => {
				ev.preventDefault();
				if ( ! buttonEl.classList.contains( 'is-addedtocart' ) ) {
					this.addToBasket( this.basketItemEl.dataset.sku, 1 )
				}
			} );
		} )
	}

	onChange( selectEl ) {
		const doRedirect = selectEl.dispatchEvent( new CustomEvent( 'changed_cart_amount.acl', { bubbles: true, cancelable: true } ) );
		if ( doRedirect ) {
			window.location.href = selectEl.value
		}
	}

	addToBasket( sku, amount = 1 ) {
		return MiniBasket.addArticleBySku( sku, amount ).then( () => {
			this.buttonEls.forEach( buttonEl => {
				buttonEl.classList.toggle( 'is-addedtocart', amount > 0 );
			} )
		} )
	}
}

const initAmountSelector = ( scopeEl = document ) => {
	const basketItemEls = Array.from( scopeEl.getElementsByClassName( 'mdl_article_item' ) );
	basketItemEls.forEach( basketItemEl => {
		basketItemEl.ACL_AMOUNT_SELECTOR_HANDLER ??= new BasketItemActions( basketItemEl );
	} );

	const voucherFormEl = document.getElementById( 'voucherform' );
	const voucherButtonEl = document.getElementById( 'submitcode' );
	const voucherInputEl = document.getElementById( 'cart_voucher_number' );
	if ( voucherFormEl && voucherInputEl ) {
		const voucherLinkEls = document.querySelectorAll( 'a[data-voucher-code]' );
		voucherLinkEls.forEach( linkEl => {
			linkEl.addEventListener( 'click', ( ev ) => {
				ev.preventDefault();
				voucherInputEl.value = linkEl.dataset.voucherCode;
				voucherInputEl.dispatchEvent( new CustomEvent( 'change', { bubbles: true} ) );
				submitcode.click();
			} )
		} )
	}

}

whenReady.then( () => initAmountSelector() );

export {
	BasketItemActions as default,
	initAmountSelector,
}
